<div
  class="d-flex justify-content-end btn--uploads"
  [class]="lang.isRTL ? 'float-start' : ''"
>
  <div class="d-flex btn--upload amplify" (click)="openModal()">
    <img src="assets/img/amplify-logo.svg" />
  </div>
</div>
